import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuizSystemModule } from '../quiz-system/quiz-system.module';

import { ModuleFheComponent } from './module-fhe/module-fhe.component';
import { ModulePageFheComponent } from './module-page-fhe/module-page-fhe.component';

@NgModule({
  declarations: [
    ModuleFheComponent,
    ModulePageFheComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    QuizSystemModule
  ]
})
export class FairHousingEducationModule { }
